var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['bk-ava', { 'bk-ava--lg': _vm.grande }],attrs:{"aria-hidden":"true"}},[(_vm.src && !_vm.rota)?_c('img',{attrs:{"src":_vm.src,"alt":"","loading":"lazy"},on:{"error":function($event){_vm.rota = true}}}):[_vm._v(_vm._s(_vm.inicial))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }